import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-10 text-center animate-fade-in',
        className,
      )}
    >
      <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={cn(icon, 'text-2xl leading-none')} aria-hidden="true" />
      </span>
      <p className="text-sm font-semibold text-foreground-800">{title}</p>
      {description ? <p className="mt-1 max-w-md text-sm text-foreground-500">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}